import { useNavigate } from "react-router-dom";

import { useSessionStore } from "@/modules/auth/store/useSessionStore";
import { LogoutIcon } from "@/modules/common/assets/icons";
import { Button, Tooltip } from "@/modules/common/components";
import { ADMIN_USER_ROLE_OPTIONS } from "@/modules/common/types/Users.enum";
import { formatNameInitials } from "@/modules/common/utils/format";
import { ROUTES } from "@/routes/constants/routes";
import { cn } from "@/libs/cn";

interface SidebarUserProps {
  isExpanded: boolean;
}

const SidebarUser = ({ isExpanded }: SidebarUserProps) => {
  const { session, clearSession } = useSessionStore();
  const navigate = useNavigate();

  if (!session) return null;

  const user = session.user;
  const nameInitials = formatNameInitials(user.name);
  const roleLabel = ADMIN_USER_ROLE_OPTIONS.find((option) => option.value === String(user.role))?.label ?? "-";

  const logout = () => {
    clearSession();
    navigate(ROUTES.AUTH.LOGIN);
  };

  return (
    <div className={cn("flex items-center p-2 gap-2", isExpanded ? "justify-between" : "flex-col justify-center")}>
      <div className="flex items-center gap-2 min-w-0">
        <div className="flex items-center justify-center rounded-full bg-brand-primary text-brand-primary-contrast text-sm font-semibold h-8 w-8 shrink-0">
          {nameInitials}
        </div>

        {isExpanded && (
          <div data-test="sidebar-user" className="flex flex-col text-brand-secondary-contrast w-36 overflow-hidden">
            <Tooltip label={user.name}>
              <span className="text-sm truncate block">{user.name}</span>
            </Tooltip>
            <span className="text-xs text-brand-secondary-contrast/70 text-left truncate block">{roleLabel}</span>
          </div>
        )}
      </div>

      <Tooltip label="Sair" side="right" disabled={isExpanded}>
        <Button
          variant="text"
          data-test="logout-button"
          className="text-brand-secondary-contrast hover:bg-brand-secondary-contrast/10"
          icon={<LogoutIcon />}
          onClick={() => logout()}
        />
      </Tooltip>
    </div>
  );
};

export default SidebarUser;
